import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, { siteKey: '6Lc107gUAAAAAObID9hRzUpPrXsf4TVB5aS58YjW' })
